export default __webpack_public_path__ + "images/619e514481a4d09462176a790c0f6840-weeklyMotivation.png";